import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { ISalesFunnel } from '@user/store/salesFunnel'
import { LeadAssignmentRuleFormModel } from '../../../../typings'

type Props = {
  name: string
}

export function useHandlers(props: Props) {
  const { name } = props
  const { setFieldValue } = useFormikContext<LeadAssignmentRuleFormModel>()

  const handleChange = useCallback(
    (value: ISalesFunnel | null) => {
      setFieldValue(name, value?.id ?? '')
      if (!value) setFieldValue('leadStatusId', '')
    },
    [setFieldValue, name],
  )

  return {
    handleChange,
  }
}
